module.exports = __webpack_public_path__ + "img/woman.5db9ae83.png";